import { Radio } from "antd";
import styled from "styled-components";
import color from "../_style/color";

export default styled(Radio)`
  .ant-radio-inner {
    background-color: ${color.veryLightGrey};
  }
  .ant-radio-wrapper:hover .ant-radio,
  .ant-radio:hover .ant-radio-inner,
  .ant-radio-input:focus + .ant-radio-inner,
  .ant-radio-checked .ant-radio-inner {
    background-color: ${color.primary};
  }
  .ant-radio-checked .ant-radio-inner {
    border-color: ${color.primary};
  }
  .ant-radio-inner::after {
    background-color: ${color.light};
  }
`;
